export const notificationsTableName = "arb_t2_user_notification"
export const analyticsTableName = "arb_t2_analytics"
export const pricesTableName = "arb_t2_price_history"
export const notificationsIndexName = "backend_notifications"
export const tokensTableName = "arb_t2_tokens"
export const poolsTableName = "arb_t2_pools"
export const poolsSameNameIndex = "same_name_pools"

export const userTableName = "arb_t2_user"
